import React, { useEffect, useState } from 'react';
import { Box } from '@chakra-ui/react';
import Loader from '../Loader';

interface PageLoaderWrapperProps {
  isLoading: boolean;
  children: React.ReactNode;
  /** Текст для отображения под лоадером */
  loadingText?: string;
  /** Размер лоадера */
  loaderSize?: 'small' | 'medium' | 'large';
  /** Цвет лоадера */
  loaderColor?: 'primary' | 'secondary' | 'white' | 'success' | 'error';
  /** Тип лоадера */
  loaderVariant?: 'spinner' | 'dots' | 'pulse' | 'skeleton';
}

const PageLoaderWrapper: React.FC<PageLoaderWrapperProps> = ({
  isLoading,
  children,
  loadingText = 'Загрузка данных...',
  loaderSize = 'large',
  loaderColor = 'primary',
  loaderVariant = 'spinner'
}) => {

  const [showLoader, setShowLoader] = useState(isLoading);

  useEffect(() => {
    if (isLoading) {
      setShowLoader(true);
    } else {
      // Скрываем лоадер с задержкой
      const hideLoaderTimer = setTimeout(() => {
        setShowLoader(false);
      }, 250);

      return () => {
        clearTimeout(hideLoaderTimer);
      };
    }
  }, [isLoading]);

  return (
    <Box position="relative" width="100%">
      {/* Лоадер */}
      <Box
        position={showLoader ? "static" : "absolute"}
        top={0}
        left={0}
        right={0}
        bottom={0}
        display={showLoader ? "flex" : "none"}
        justifyContent="center"
        alignItems="center"
        minHeight="50vh"
        width="100%"
        zIndex={showLoader ? 10 : -1}
      >
        <Loader
          size={loaderSize}
          color={loaderColor}
          variant={loaderVariant}
          text={loadingText}
          showText={true}
          fullscreen={false}
        />
      </Box>

      {/* Контент */}
      <Box
        opacity={showLoader ? 0 : 1}
        visibility={showLoader ? "hidden" : "visible"}
      >
        {children}
      </Box>
    </Box>
  );
};

export default PageLoaderWrapper; 